import { createRecordType, defineMigrations } from "@supersig/store";
import { T } from "@supersig/validate";
import { nanoid } from "nanoid";
import { idValidator } from "../misc/id-validator";
export const PaywallSurveyValidator = T.model("paywall_survey", T.object({
    id: idValidator("paywall_survey"),
    typeName: T.literal("paywall_survey"),
    surveyId: T.number
}));
export const SWPaywallSurveyRecordType = createRecordType("paywall_survey", {
    migrations: defineMigrations({}),
    validator: PaywallSurveyValidator,
    scope: "document"
}).withDefaultProperties(()=>({}));
export function isPaywallSurvey(record) {
    if (!record) return false;
    return record.typeName === "paywall_survey";
}
export function isPaywallSurveyId(id) {
    if (!id) return false;
    return id.startsWith("paywall_survey:") && (id.endsWith("ON_MANUAL_CLOSE") || id.endsWith("ON_PURCHASE"));
}
/** @public */ export function createPaywallSurveyId(id) {
    return `paywall_survey:${id ?? nanoid()}`;
}
export const closePaywallSurveyId = createPaywallSurveyId("ON_MANUAL_CLOSE");
export const postPurchaseSurveyId = createPaywallSurveyId("ON_PURCHASE");
